const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      initialZoomLevel: 'fill',
      secondaryZoomLevel: 'fit',
      scaleMode: 'zoom',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: true,
      arrowNext: true,
      arrowPrevSVG:
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 5 6"><path fill="#fff" d="M5 6 0 3l5-3v6Z"/></svg>',
      arrowNextSVG:
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 5 6"><path fill="#fff" d="m0 0 5 3-5 3V0Z"/></svg>',
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    // parse video-url attribute
    this.photoSwipeInstance.addFilter('itemData', (itemData, index) => {
      const videoUrl = itemData.element.dataset.videoUrl
      if (videoUrl) {
        itemData.videoUrl = videoUrl
      }
      return itemData
    })

    // override slide content
    this.photoSwipeInstance.on('contentLoad', (e) => {
      const { content } = e
      if (content.type === 'video') {
        // prevent the default behavior
        e.preventDefault()

        // Create a container for iframe
        // and assign it to the `content.element` property
        content.element = document.createElement('div')
        content.element.className = 'pswp__video-container'

        const videoEl = document.createElement('video')
        videoEl.src = content.data.videoUrl
        videoEl.autoplay = true
        videoEl.loop = true
        videoEl.setAttribute('muted', true)
        videoEl.setAttribute('playsinline', true)
        content.element.appendChild(videoEl)
      }
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: 'Close',
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
